<div id="geo-location-selector-page">
  <div class="geo-location-selector-container">
    <div class="geo-location-selector-header">
      <span>{{ TranslationKeys.GeneralLocation | translate }}</span>
    </div>
    <div class="geo-location-selector-info">
      {{ TranslationKeys.GeoLocationChooseGeoLocation | translate }}
    </div>
    <div class="geo-location-selector-content">
      <nimbus-location-list
        [formControl]="control$ | async"
        [locations]="availableLocations$ | async"
        [allowToPreSelectLocation]="false"
        [position]="'vertical'"
      ></nimbus-location-list>
    </div>
    <div class="button-group-controls flex-container flex-align-center-right">
      <button nimbusPrimaryButton class="merge" [disabled]="!selectedLocation" (click)="apply()">
        {{ TranslationKeys.GeneralSelect | translate }}
      </button>
    </div>
  </div>
</div>
